import styled from 'styled-components';

export const ContainerNoItems = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  margin: 100px;
  flex-basis: 100%;
`
